import { DomainBaseComponent } from '@/shared/domain-base.component';
import { EmailService } from '@/shared/email.service';
import { PrintFns } from '@/shared/print-fns';
import { ShippingService } from '@/shipping/shipping.service';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Account, ReturnRequestDetail } from 'app/model/entities/entity-model';
import { DomainService } from 'app/shared/domain.service';
import { takeUntil } from 'rxjs';

@Component({
    templateUrl: './restock-fee-printable.component.html',
    standalone: false
})
export class RestockFeePrintableComponent extends DomainBaseComponent implements OnInit, OnDestroy {
  @ViewChild("printableArea") printElementRef: ElementRef;

  account: Account;
  returnRequestDetails: ReturnRequestDetail[];

  constructor(
    protected domainService: DomainService,
    protected route: ActivatedRoute,

    private emailService: EmailService,
    private shippingService: ShippingService,
    private elementRef: ElementRef
  ) {
    super(domainService);
    this.route.queryParamMap.pipe(takeUntil(this.onDestroy)).subscribe(() => {
      this.updateFromContext();
    });
  }

  ngOnInit(): void {
    // this.updateFromContext();
  }

  private async updateFromContext() {

    const accountId = this.route.snapshot.params["accountId"];

    // ReturnRequestDetail Ids, comma-separated
    const rrids = this.route.snapshot.queryParams['rrids'];

    if (!accountId || !rrids) {
      throw new Error("Invalid parameters to restock-fee-printable");
    }

    [this.account, this.returnRequestDetails] = await Promise.all([
      this.dbQueryService.getAccount(accountId),
      this.dbQueryService.getReturnRequestDetailsForRestockInvoice(rrids)
    ]);
      
    this.isPageReady = true;

    setTimeout(() => {
      // if printing or headless browser, use print view
      const mediaQueryList = window.matchMedia("print");
      if (mediaQueryList.matches || window.navigator.userAgent.includes("Headless")) {
        this.preparePrint();
      }
    }, 0);

  }

  preparePrint() {
    let el: HTMLElement =
      this.printElementRef && this.printElementRef.nativeElement;
    if (el == null) {
      el = this.elementRef && this.elementRef.nativeElement;
    }
    if (!el) {
      return;
    }
    PrintFns.printElement(el);
  }

}
